import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyClUDO4rvtOJsEIPiddWHvnDeszHXZf96A",
  authDomain: "starmarket-f0b1b.firebaseapp.com",
  projectId: "starmarket-f0b1b",
  storageBucket: "starmarket-f0b1b.firebasestorage.app",
  messagingSenderId: "819602972037",
  appId: "1:819602972037:web:38f17f17a4a64e2ed478ec",
  measurementId: "G-W8VNYFCP1N",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
let messaging;
// Check if messaging is supported
isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(app);
    console.log("Firebase Messaging is supported.");
    // Add your messaging logic here
  } else {
    console.warn("Firebase Messaging is not supported in this browser.");
  }
});
//const messaging = getMessaging(app);

export { messaging };
